import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import $ from "jquery";

$.get({url: 'https://unlcms.unl.edu/wdn/templates_5.1/includes/global/head-1.html',
  dataType: "text",}
).then( (head1) => {
  $.get('https://unlcms.unl.edu/wdn/templates_5.1/includes/global/head-2.html').then( (head2) => {
    $("head").append(head1 + head2)
  })
}).always( () => {
  bootstrapApplication(AppComponent, appConfig)
    .catch((err) => console.error(err));
})

